import {Injectable, IterableDiffers} from '@angular/core';
import {API_URLS} from '../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../shared/services/api-helper/api-helper.service';
import {Group} from '../models/group.model';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  constructor(private api: APIHelper) {}

  public getAllGroups(): Promise<Group[]> {
    return this.api.requestApi({ action: API_URLS.groups.getAll }).then(res => {
      res.list.entries.slice().reverse().forEach(function(item, index, object) {
        if (item.entry.id.includes('site_') || item.entry.id.includes('ALFRESCO_MODEL_') || item.entry.id.includes('ALFRESCO_SEARCH_')) {
          res.list.entries.splice(object.length - 1 - index, 1);
        }
      });
      return res.list.entries.map(g => {
        return new Group(g.entry);
      });
    });
  }

  public getGroupsForUser(userId: string): Promise<Group[]> {
    return this.api
      .requestApi({
        action: API_URLS.groups.getForUser.replace(':userId', userId)
      })
      .then(res => {

       
        return res.list.entries.map(g => {
          return new Group(g.entry);
        });
      });
  }

  public delete(groupId: string): Promise<boolean> {
    return this.api
      .requestApi({
        action: API_URLS.groups.delete.replace(':groupId', groupId),
        method: 'DELETE'
      })
      .then(res => {
        return res;
      });
  }

  public create(data: any): Promise<any> {
    return this.api
      .requestApi({ action: API_URLS.groups.add, method: 'POST', datas: data })
      .then(res => {
        return res;
      });
  }

  public edit(data: any, id: string): Promise<any> {
    return this.api
      .requestApi({
        action: API_URLS.groups.edit.replace(':groupId', id),
        method: 'PUT',
        datas: data
      })
      .then(res => {
        return res;
      });
  }

  public getOne(id: string): Promise<Group> {
    return this.api
      .requestApi({ action: API_URLS.groups.getOne.replace(':groupId', id) })
      .then(res => {
        return new Group(res);
      });
  }

  public getMembers(id: string) {
    return this.api
      .requestApi({
        action: API_URLS.groups.getMembers.replace(':groupId', id)
      })
      .then(res => {
        return res;
      });
  }
  public addMember(groupId: string, memberId: string, data: any): Promise<any> {
    return this.api
      .requestApi({
        action: API_URLS.groups.addMembers
          .replace(':groupId', groupId)
          .replace(':memberId', memberId),
        method: 'POST',
        datas: data
      })
      .then(res => {
        return res;
      });
  }

  public deleteMember(groupId: string, memberId: string): Promise<any> {
    return this.api
      .requestApi({
        action: API_URLS.groups.addMembers
          .replace(':groupId', groupId)
          .replace(':memberId', memberId),
        method: 'DELETE'
      })
      .then(res => {
        return res;
      });
  }
}
